import { PagesState } from '../reducers/pages';
import { decodeUTF8Bytes } from '../utils/string';
import { initPreferenceState } from '../reducers/preference';
import { initDrawingToolState } from '../drawing/reducers/drawingTool';
import {
   initIntegratedDrawingState, jsonizeIntegratedDrawingData,
 } from '../reducers/integratedDrawing';
import { initSpeechState } from '../tts/reducers/speech';
import { UserData } from '../../../..';
import { initUIState } from '../reducers/ui/ui';

interface PartialWorkspace {
  publicationId: string;
  pages: PagesState;
}

function copyText(text: string): void {
  const textarea: HTMLTextAreaElement = document.createElement('textarea');
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
}

function packPartialWorkspace(src: PartialWorkspace): string {
  // stringifyしたあとさらにhexにするのは文字数的にとても無駄だが、
  // URLに内部仕様が露出するのがなんとなく気持ち悪いので数字にしておく。
  // TODO : 圧縮したバイナリをhexにするなどした方が効率的。
  const dataString = JSON.stringify(src);
  const dataBuffer = (new TextEncoder).encode(dataString);
  let retval = '';
  for (let i = 0; i < dataBuffer.byteLength; i += 1) {
    const b = dataBuffer[i];
    let hex = b.toString(16);
    if (b < 0x10) {
      hex = `0${hex}`;
    }
    retval += hex;
  }
  return retval;
}

function unpackPartialWorkspace(hexString: string): PartialWorkspace {
  const buffer = new ArrayBuffer(hexString.length / 2);
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < hexString.length / 2; i += 1) {
    bytes[i] = parseInt(hexString.substr(i * 2, 2), 16);
  }

  return JSON.parse(decodeUTF8Bytes(bytes));
}

export function generateAndCopyPartialWorkspaceURL(src: PartialWorkspace): void {
  const url = `viewer.html?workspaceData=${packPartialWorkspace(src)}`;
  copyText(url);
  alert('クリップボードにコピーしました');
}

export function createUserdataFromPartialWorkspaceString(hexString: string): UserData {
  const decoded = unpackPartialWorkspace(hexString);

  return {
    publicationId: decoded.publicationId,
    createdAt: null,
    pages: decoded.pages,
    preference: initPreferenceState(),
    drawingTool: initDrawingToolState(),
    integratedDrawings: jsonizeIntegratedDrawingData(initIntegratedDrawingState()),
    speech: initSpeechState(),
    contentStorage: [],
    markers: [],
    bookmarks: [],
    popupRects: {},
    ui: initUIState(),
  };
}
